import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders,HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class FacetsService {

  private httpOptions: any;
  private httparams:any;
  public errors: any = [];
  public apiurl:string;

    constructor(private http: HttpClient) { 
       this.apiurl=environment.pythonUrl;      
    }


  insertQryHistory(filters:any,keyword:any,Username:string){
      var qq=JSON.stringify(filters);
      var tokens="JWT " + sessionStorage.getItem('token');
      console.log({'keyword':keyword,'filters':qq,'username':Username});

      this.httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json', 'Authorization':tokens})
      };
      this.http.post(this.apiurl + '/ql/getquery/',{'keyword':keyword,'filters':qq,'username':Username}, this.httpOptions).subscribe(
        data => {             
          console.log(data);                   
        },
        err => {
          console.error('login error', err);
          this.errors = err['error'];
        }
      );
    }

    fetchAllQry(): Observable<any>{
      var tokens="JWT " + sessionStorage.getItem('token');

      this.httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json', 'Authorization':tokens}),
        // params: new HttpParams().set("id",'27')
      };
      return this.http.get(this.apiurl + '/ql/getquery',this.httpOptions);
    }

    fetchQryByName(username:any): Observable<any>{
      console.log(username);
      var tokens="JWT " + sessionStorage.getItem('token');

      this.httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json', 'Authorization':tokens}),
        params: new HttpParams().set("username",username)
      };
      return this.http.get(this.apiurl + '/ql/getquery',this.httpOptions);
    }

    fetchById(id:any):Observable<any>{
      var tokens="JWT " + sessionStorage.getItem('token');

      this.httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json', 'Authorization':tokens}),
        params: new HttpParams().set("id",id)
      };
      return this.http.get(this.apiurl + '/ql/getquery',this.httpOptions);
    }

    deleteQry(id:any):Observable<any>{
      
      var tokens="JWT " + sessionStorage.getItem('token');
      console.log(tokens+"  delete")

      this.httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json', 'Authorization':tokens}),
        params: new HttpParams().set("id",id)
      };
      return this.http.delete(this.apiurl + '/ql/getquery',this.httpOptions);


    }

    getFacetMappings(){
      return this.http.get('assets/configs/FacetsMapping.json');        
    }
    getshowHideFacets(){
      return this.http.get('assets/configs/ShowHideFacets.json');
        
    }
    getViewMappings(){
      return this.http.get('assets/configs/ViewMapping.json');
        
    }
    
}